'use strict';

angular.module('ClinicApp').factory('LanguageService', function(LanguageResource) {
  return {
    listLanguages: function() {
      return LanguageResource.query().$promise;
    },
  };
});
